import { useEffect, useRef } from 'react';
import { throttle } from 'lodash';

export const useThrottle = (
  callback: (...args: any[]) => void,
  wait?: number,
  option?: { leading?: boolean; trailing?: boolean },
) => {
  const callbackRef = useRef<Function>();

  useEffect(() => {
    callbackRef.current = callback;
  });

  const handle = useRef(
    throttle<any>(
      (...args) => {
        return callbackRef.current!(...args);
      },
      wait,
      option,
    ),
  );
  return handle.current;
};
